import { keepPreviousData } from '@tanstack/react-query';
import type { TRPC } from './types';

const LIST_STALE_TIME = 5 * 60 * 1000;

export const articleKeys = {
  byTag: (trpc: TRPC) => trpc.articles.byTag.pathKey(),
  list: (trpc: TRPC) => trpc.articles.list.pathKey(),
  latest: (trpc: TRPC) => trpc.articles.latest.pathKey(),
  news: (trpc: TRPC) => trpc.articles.news.pathKey(),
};

type ByTagArgs = {
  trpc: TRPC;
  infopankId: string;
  conceptType: string;
  from: number;
  limit: number;
};

export const byTagQueryOptions = ({ trpc, infopankId, conceptType, from, limit }: ByTagArgs) =>
  trpc.articles.byTag.queryOptions(
    { infopankId, conceptType, from, limit },
    {
      placeholderData: keepPreviousData,
      staleTime: LIST_STALE_TIME,
    },
  );

type ListArgs = {
  trpc: TRPC;
  from: number;
  limit: number;
  excludeId?: string;
};

export const listQueryOptions = ({ trpc, from, limit, excludeId }: ListArgs) =>
  trpc.articles.list.queryOptions(
    { from, limit, excludeId },
    {
      placeholderData: keepPreviousData,
      staleTime: LIST_STALE_TIME,
    },
  );

export const latestQueryOptions = ({ trpc }: { trpc: TRPC }) =>
  trpc.articles.latest.queryOptions(undefined, {
    staleTime: LIST_STALE_TIME,
  });

export const newsQueryOptions = ({ trpc, infopankId }: { trpc: TRPC; infopankId: number }) =>
  trpc.articles.news.queryOptions(
    { infopankId },
    {
      staleTime: LIST_STALE_TIME,
    },
  );
